import FacturaDelete from './FacturaDelete'
export {FacturaDelete}
export default FacturaDelete
